
import front from '@/../static/js/proto/CtpFront';
import art from '@/../static/js/proto/art/Art';
import _ from 'lodash';
import Vue from 'vue';
import { Toast, Indicator, MessageBox } from 'mint-ui';

export function updArrayById(data, array: any[]) {
  const index = _.findIndex(array, r => r.id === data.id);
  // 删除
  if (data.stamp === art.meta.stamp_remove) {
    if (index !== -1) {
      Vue.delete(array, index);
    }
    return;
  }
  // 新增
  if (index === -1) {
    array.push(data);
  } else {
    // 已存在: 覆盖
    Vue.set(array, index, data);
  }
}
export function clearArr(arr: any[]) {
  for (let i = arr.length - 1; i >= 0; i--) {
    Vue.delete(arr, i);
  }
}
export function isZero(n: string | number) {
  let k: number;
  if (typeof n === 'string') {
    k = parseFloat(n);
  } else {
    k = n;
  }
  if (k === 0 || isNaN(k)) {
    return true;
  }
  return false;
}
export function isParentOfEventElement(parent: Node, event: Event) {
  const e = event as any;
  const path: any[] = e.path || (e.composedPath && e.composedPath());

  if (path) {
    return path.includes(parent);
  } else {
    let ele = event.target as Node | null;
    while (ele) {
      if (ele === parent) {
        return true;
      }
      ele = ele.parentNode;
    }
    return false;
  }
}
export function toast(message: string) {
  Toast({
    message,
    position: 'bottom',
    duration: 3000,
  });
}

export function indicator(msg: string) {
  Indicator.open(msg);
}
export function closeIndicator() {
  Indicator.close();
}
export function confirm(messages: string, titles: string, confirmButtonTexts: string, cancelButtonTexts: string) {
  return MessageBox.confirm('', {
    message: messages,
    title: titles,
    confirmButtonText: confirmButtonTexts,
    cancelButtonText: cancelButtonTexts,
    showCancelButton: true,
  });
}



// WEBPACK FOOTER //
// ./src/utils/utils.ts